"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeRestDepartmentImage = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
class IkeRestDepartmentImage {
    constructor(boundDepartment) {
        this.boundDepartment = boundDepartment;
    }
    capture(imageData, metadata) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const core = this.boundDepartment.boundUser.core;
            const headers = core.headers(this.boundDepartment.boundUser.accessToken, this.boundDepartment.departmentId);
            headers[core_api_1.IkeRequestHeader.CONTENT_TYPE] = 'image/jpeg';
            headers[core_api_1.IkeRequestHeader.REQUEST_ARGS] = JSON.stringify(metadata);
            const response = yield core.fetch(core.path(`/v1/action/capture.image.create`), {
                method: 'POST',
                body: imageData,
                headers,
            });
            if (response.ok) {
                yield core.validateIsJson(response);
                return response.json();
            }
            return core.handleError(response);
        });
    }
    image(uuid, imageData, zoom, collectedAt) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.capture(imageData, {
                type: 'image',
                zoom,
                collectedAt: collectedAt.toISOString(),
                uuid,
                metadata: undefined,
            });
        });
    }
}
exports.IkeRestDepartmentImage = IkeRestDepartmentImage;
//# sourceMappingURL=rest.department.image.js.map